import request from "utils/request";

export async function getPromoterInfo() {
  return request.get("/profile/getPromoterInfo.php", "nocache");
}

export async function updatePromoter(data) {
  return request.post("/profile/updatePromoter.php", data, "nocache");
}

export async function checkUpdatePromoter() {
  return request.get("/profile/checkUpdatePromoter.php", "nocache");
}

export async function getLink() {
  return request.get("/admin/system/getLink.php", "nocache");
}

export async function getService(type) {
  return request.get(
    `/profile/onlineCustomerService.php?type=${type}`,
    "nocache",
  );
}

export async function getQAList(currentPage, title) {
  return request.get(
    `/profile/onlineCustomerQuestion.php?currentPage=${currentPage}&pageSize=50&title=${title}`,
    "nocache",
  );
}

export async function getInvite(currentPage) {
  return request.get(`/my/inviteRecord.php?currentPage=${currentPage}`);
}

export async function myProductList(currentPage, pageSize) {
  return request.get(
    `/product/myProductList.php?currentPage=${currentPage}&pageSize=${pageSize}`,
  );
}

export async function getUserProductInfo(currentPage, pageSize) {
  return request.get(`/product/getUserProductInfo.php`);
}

export async function appCardQr() {
  return request.post("/wxampcard/appCardQr.php", "nocache");
}

export async function myCouponList(type, currentPage, pageSize = 50) {
  return request.get(
    `/integral/myCouponList.php?currentPage=${currentPage}&pageSize=${pageSize}&type=${type}`,
    "nocache",
  );
}

export async function getUserLoginDevice() {
  return request.get(`/profile/getUserLoginDevice.php`, "nocache");
}

export async function deleteDeviceToken(data) {
  return request.post("/profile/deleteDeviceToken.php", data, "nocache");
}

export async function getMedalClass() {
  return request.get(`/medal/getMedalClass.php`, "nocache");
}

export async function getMedalLevel(id) {
  return request.get(`/medal/getMedalLevel.php?id=${id}`, "nocache");
}

export async function getMedalLevelDetails(id) {
  return request.get(`/medal/getMedalLevelDetails.php?id=${id}`, "nocache");
}

export async function getMedalWall() {
  return request.get(`/medal/getMedalWall.php`, "nocache");
}

export async function getMemberMedal() {
  return request.get(`/medal/getMemberMedal.php`, "nocache");
}
export async function getRegMedal() {
  return request.get(`/medal/getRegMedal.php`, "nocache");
}

export async function getGameAudio(data) {
  return request.post("/materials/getGameAudio.php", data, "nocache");
}

export async function getMaterialsByGame(data) {
  return request.post("/materials/getMaterialsByGame.php", data, "nocache");
}

export async function logoutApi(data) {
  return request.post("/profile/logout.php", data, "nocache");
}

export async function demoAnswerV2() {
  return request.get("/lesson/demoAnswerV2.php", "nocache");
}

export async function submitAnswerV3(data) {
  return request.post("/lesson/submitAnswerV3.php", data, "nocache");
}

export async function getAnswerV3(id) {
  return request.get(`/lesson/getAnswerV3.php?id=${id}`, "nocache");
}

export async function spokenSubmitAnswer(data) {
  return request.post("wxampcard/spokenSubmitAnswer.php", data, "nocache");
}

export async function getAllMedals(tab_type) {
  return request.get(
    `/medalv2/getAllMedals.php?tab_type=${tab_type}`,
    "nocache",
  );
}

export async function getMedalJourney() {
  return request.get(`/medalv2/getMedalJourney.php`, "nocache");
}

export async function gitShareModalImage(data) {
  return request.post("/medal/gitShareModalImage.php", data, "nocache");
}

export async function getMedalDetails(category_id, level) {
  return request.get(
    `/medalv2/getMedalDetails.php?category_id=${category_id}&level=${level}`,
    "nocache",
  );
}

export async function getLessonMedal() {
  return request.get(`/medalv2/lessonMedal.php`, "nocache");
}

export async function getIntegralMedal() {
  return request.get(`/medalv2/integralMedal.php`, "nocache");
}
